
import { useTranslation } from "react-i18next";
import { PageContainer } from "@/components/PageContainer";
import { PageHeader } from "@/components/PageHeader";

export default function Meetings() {
  const { t } = useTranslation();
  
  return (
    <PageContainer>
      <PageHeader 
        title={t("meetings.title")} 
        subtitle={t("meetings.subtitle")}
      />
      {/* Content will be added in the future */}
    </PageContainer>
 );
}
